import { saveAs } from 'file-saver';
import XLSX from 'sheetjs-style';

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

export const exportToExcel = async (fileName: string, data: any[]) => {
  if (!data.length) return;
  const ws = XLSX.utils.json_to_sheet(data);

  const cols = Object.keys((data[0])).map((x) => ({ width: 20 }));
  ws['!cols'] = cols;
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const dataFile = new Blob([excelBuffer], { type: fileType });
  saveAs(dataFile, fileName + fileExtension);
};
